import { render, staticRenderFns } from "./WizardMap.vue?vue&type=template&id=89b00c16&scoped=true"
import script from "./WizardMap.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardMap.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardMap.vue?vue&type=style&index=0&id=89b00c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b00c16",
  null
  
)

export default component.exports